import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { REJECTION_REASON_MAX, formatAmount } from "../../../utilities/expenses";

/**
 * Asks the leader why an expense is being rejected. The reason is required
 * and is shown to the player in their push and on their expense list.
 */
const RejectExpenseDialog = ({ expense, submitting, onCancel, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [touched, setTouched] = useState(false);

  // Fresh text box for every expense.
  useEffect(() => {
    setReason("");
    setTouched(false);
  }, [expense?._id]);

  const trimmed = reason.trim();
  const showError = touched && !trimmed;

  const submit = () => {
    setTouched(true);
    if (!trimmed || submitting) return;
    onConfirm(trimmed);
  };

  return (
    <Dialog open={!!expense} onClose={submitting ? undefined : onCancel} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600 }}>Reject expense</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary" mb={2}>
          {expense?.user_id?.name || "This team member"} will be told why their{" "}
          {expense?.type} expense of ₹{formatAmount(expense?.amount)} was rejected.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          label="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value.slice(0, REJECTION_REASON_MAX))}
          onBlur={() => setTouched(true)}
          error={showError}
          helperText={
            showError
              ? "A reason is required"
              : `${reason.length}/${REJECTION_REASON_MAX}`
          }
          inputProps={{ maxLength: REJECTION_REASON_MAX }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={submit}
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectExpenseDialog;
